<div class="field field-text" [ngClass]="">
  @if (label) {
    <span class="label">{{label}}</span>
  }
  <div class="d-flex align-items-center justify-content-between full-border" [class.error-field]="error">
    <input
      [type]="getType()"
      type="text"
      class="flex-grow-1"
      autocomplete="new-password"
      [readonly]="false"
      style="max-width: 360px;"
      (ngModelChange)="emit(null)"
      [(ngModel)]="localModel"
      (keyup.enter)="emit(null); enter.emit()"
      />
    <div class="button-wrapper">
      @if (localModel && localModel.length) {
        <app-button
          classes="primary-light password-button"
          tabindex="-1"
          [text]="togglePwd ? ('inlog_password_hide' | translate) : ('inlog_password_show' | translate)"
          (emitClick)="togglePwd = !togglePwd"
        ></app-button>
      }
    </div>

  </div>
  @if (error && error !== 'true') {
    <span class="error-field-display">{{error}}</span>
  }
  @if (!hideCheck) {
    <div class="conditions d-flex">
      <div class="condition" [class.active]="valid('lower')">
        <div class="top">a</div>
        <div class="bot">{{'fieldpassword_condition_lowercase' | translate}}</div>
      </div>
      <div class="condition" [class.active]="valid('upper')">
        <div class="top">A</div>
        <div class="bot">{{'fieldpassword_condition_uppercase' | translate}}</div>
      </div>
      <div class="condition" [class.active]="valid('number')">
        <div class="top">9</div>
        <div class="bot">{{'fieldpassword_condition_number' | translate}}</div>
      </div>
      <div class="condition" [class.active]="valid('special')">
        <div class="top">#</div>
        <div class="bot">{{'fieldpassword_condition_special' | translate}}</div>
      </div>
      <div class="condition" [class.active]="valid('amount')">
        <div class="top">8+</div>
        <div class="bot">{{'fieldpassword_condition_amount' | translate}}</div>
      </div>
    </div>
  }
</div>